import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";

const RSVPPage = () => {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    numberOfGuests: 1,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [rsvpStats, setRsvpStats] = useState({ totalGuests: 0, totalRSVPs: 0 });
  const formatDateTimeForInput = (dateString) => {
    const date = new Date(dateString);
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  useEffect(() => {
    const fetchEventAndRSVPs = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URLVAR}/api/event/slug/${slug}`
        );
        console.log(response.data.event);
        setEvent(response.data.event);

        const rsvpRes = await axios.get(
          `${process.env.REACT_APP_URLVAR}/api/event/rsvps/noOfguest/${response.data.event._id}`
        );
        setRsvpStats(rsvpRes.data);
      } catch (err) {
        console.error("Error fetching RSVP stats:", err);
      }
    };

    fetchEventAndRSVPs();
  }, [slug]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRSVPSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_URLVAR}/api/event/rsvp/`, {
        eventId: event._id,
        ...formData,
      });
      setIsSubmitted(true);
    } catch (error) {
      console.error("Error RSVPing:", error);
      alert("Error RSVPing. Please try again.");
    }
  };

  const shareButtons = (
    <div className="text-center mt-4">
      <h5>Share this event:</h5>
      <div className="d-flex justify-content-center gap-3 mt-2">
        {/* Facebook */}
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            window.location.href
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="  d-flex align-items-center justify-content-center"
          style={{ width: "48px", height: "48px" }}
        >
          <i className="bi bi-facebook fs-2 text-primary"></i>
        </a>

        {/* Twitter */}
        <a
          href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
            window.location.href
          )}&text=Check out this event: ${event?.title}`}
          target="_blank"
          rel="noopener noreferrer"
          className=" rounded-circle d-flex align-items-center justify-content-center"
          style={{ width: "48px", height: "48px" }}
        >
          <i className="bi bi-twitter-x fs-2 text-black"></i>
        </a>

        {/* WhatsApp */}
        <a
          href={`https://wa.me/?text=${encodeURIComponent(
            `Check out this event: ${event?.title}\n${window.location.href}`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className=" rounded-circle d-flex align-items-center justify-content-center"
          style={{ width: "48px", height: "48px" }}
        >
          <i className="bi bi-whatsapp fs-2 text-success"></i>
        </a>
        {/* Linkdin */}
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            `Check out this event: ${event?.title}\n${window.location.href}`
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-circle d-flex align-items-center justify-content-center"
          style={{ width: "48px", height: "48px" }}
          title="Share on LinkedIn"
        >
          <i className="bi bi-linkedin fs-2 text-primary"></i>
        </a>
      </div>
    </div>
  );

  return (
    <div className="container mt-5">
      {event && !isSubmitted && (
        <>
          <Helmet>
            <title>{event.title} - RSVP</title>
            <meta property="og:title" content={event.title} />
            <meta property="og:description" content={event.shortDescription} />
            <meta property="og:image" content={event.img} />
            <meta property="og:url" content={`${window.location.href}`} />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={event.title} />
            <meta name="twitter:description" content={event.shortDescription} />
            <meta name="twitter:image" content={event.img} />
            <link href={event.img} rel="icon" />
          </Helmet>

          <h2>RSVP for {event.title}</h2>
          {event.img && (
            <div className="poster mb-3 text-center">
              <img
                src={event.img}
                alt="Event Poster"
                className="img-fluid event-poster"
              />
            </div>
          )}
          <div className="row">
            <div className="col-md-7">
              <div
                dangerouslySetInnerHTML={{ __html: event.shortDescription }}
              />
              <div className="event-details mt-3">
                {event.location && (
                  <p>
                    <strong>Location:</strong>{" "}
                    {event.locationLink ? (
                      <a
                        href={event.locationLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary text-decoration-underline"
                      >
                        {event.location}
                      </a>
                    ) : (
                      event.location
                    )}
                  </p>
                )}
                {!event.location && event.virtualLink && (
                  <p>
                    <strong>Virtual Link:</strong>{" "}
                    <a
                      href={event.virtualLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Join Event
                    </a>
                  </p>
                )}
                {event.dateTime && (
                  <p>
                    {(() => {
                      {
                        /* console.log(event.dateTime); */
                      }
                      const [date, rawTime] = formatDateTimeForInput(
                        event.dateTime
                      ).split("T");
                      console.log(rawTime);
                      const cleanTime = rawTime.replace("Z", "").split(".")[0];
                      console.log(cleanTime);
                      const [hour, minute] = cleanTime.split(":");
                      let hourNum = parseInt(hour, 10);
                      {
                        /* console.log(hourNum);  */
                      }
                      const ampm = hourNum >= 12 ? "PM" : "AM";
                      hourNum = hourNum % 12 || 12;
                      {
                        /* console.log(hourNum);  */
                      }
                      const formattedTime = `${hourNum
                        .toString()
                        .padStart(2, "0")}:${minute} ${ampm}`;
                      const [year, month, day] = date.split("-");
                      const formattedDate = `${day}-${month}-${year}`;
                      const [year1, month1, day1] = formatDateTimeForInput(
                        event.enddateTime
                      )
                        .split("T")[0]
                        .split("-");
                      const formattedDate1 = `${day1}-${month1}-${year1}`;
                      return (
                        <div>
                          <strong>Start Date:</strong> {formattedDate} <br />{" "}
                          <br />
                          <strong>End Date:</strong> {formattedDate1} <br />{" "}
                          <br />
                          <div className="">
                            <strong>Time:</strong> {formattedTime} PST
                          </div>
                        </div>
                      );
                    })()}
                  </p>
                )}
              </div>
              {/* {rsvpStats.totalGuests > 0 && ( */}
              <p>
                <strong>Total Guests Already Registered:</strong>{" "}
                {rsvpStats.totalGuests}
              </p>
              {/* )} */}

              {/* Social media buttons after form */}
              {shareButtons}
            </div>
            <div className="col-md-5">
              <form
                className="col-md-8 mx-auto border border-1 p-3 rounded"
                onSubmit={handleRSVPSubmit}
              >
                <div className="mb-3">
                  <label>Name:</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label>Email:</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label>Phone Number:</label>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label>Number of Guests:</label>
                  <input
                    type="number"
                    name="numberOfGuests"
                    value={formData.numberOfGuests}
                    min="1"
                    onChange={handleInputChange}
                    className="form-control"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-custom-primary w-100">
                  Submit RSVP
                </button>
              </form>
            </div>
          </div>
        </>
      )}

      {/* Show thank you message after form submission */}
      {isSubmitted && (
        <div className="thank-you-message text-center">
          <h2>Thank You for Your RSVP!</h2>
          <p>We look forward to seeing you at the event.</p>
          {shareButtons}
        </div>
      )}
    </div>
  );
};

export default RSVPPage;
